export const SLICES_PERSISTIDOS = [
  'catalogos',
  'userLogin',
  'creditoFiscal',
  'facturacion',
  'notaRemision',
  'notaCredito',
  'notaDebito',
  'notaDebitoExterno',
  'sujetoExcluido',
  'historial',
  'facturaExportacion',
  'comprobanteRetencion',
  'documentos',
  'formaPago',
  'comprobanteLiquidacion',
  'documentoLiquidadcion',
  'notaCreditoExterno',
  'gestionUsuario',
  'libros',
]
